// extracted by mini-css-extract-plugin
export default {"responsiveContainer":"AdminPage_responsiveContainer__09zor"};